import { FalhaServico } from '../falha-servico';

export class Protocolo{
    numeroProtocolo: number;
    dataGeracao: Date;
    documentoCliente: string;
    tipoDocumento: number;
    acaoCliente: string;
    email: string;
    falhaServico: FalhaServico;

}